import { css } from 'linaria';

export const collectionComposition = css`
  && {
    margin-bottom: 40px;

  @media (--from-tablet) and (--to-largeDesktop) {      margin-bottom: 24px;
    }

    @media (--only-mobile) {
      margin-bottom: 0;
    }
  }
`;

export const collectionProductList = css`
  display: flex;
  flex-direction: column;
  row-gap: 32px;
  width: 675px;
  min-height: 274px;

  @media (--only-desktop) {
    width: 660px;
  }

  @media (--to-desktop) {
    width: 100%;
  }

  @media (--only-mobile) {
    row-gap: 16px;
  }
`;

export const collectionProduct = css`
  display: flex;
  align-items: center;
`;

export const collectionProductImageWrapper = css`
  width: 70px;
  height: 70px;
`;

export const collectionProductImage = css`
  object-fit: contain;

  @media (--only-mobile) {
    width: 54px;
    height: 54px;
  }
`;

export const collectionProductInfo = css`
  display: flex;
  justify-content: space-between;
  width: 100%;

  @media (--only-mobile) {
    flex-direction: column;
    margin-left: 10px;
  }
`;

export const collectionProductName = css`
  display: flex;
  flex-direction: column;
  min-width: 350px;
  margin-right: 50px;
  margin-left: 16px;
  row-gap: 4px;

  @media (--only-mobile) {
    min-width: 100%;
    margin: 0 0 10px;
  }
`;

export const collectionProductPriceBlock = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  @media (--only-mobile) {
    margin-bottom: 8px;
  }
`;

export const collectionProductPriceWrapper = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;

  @media (--only-mobile) {
    align-items: flex-start;
  }
`;

export const collectionProductTwoRowsPriceWrapper = css`
  @media (--from-tablet) {
    justify-content: flex-end;
  }
`;

export const collectionProductInfoDivider = css`
  @media (--from-tablet) {
    display: none;
  }
`;
